import { browser } from '$app/env';

export type Theme = 'chartium-light' | 'chartium-dark';

let theme = $state<Theme>(
  (browser ? (localStorage.getItem('theme') as Theme) : null) ?? 'chartium-dark',
);

export function getTheme() {
  return theme;
}

export function isThemeDark() {
  return theme === 'chartium-dark';
}

export function setTheme(theme_: Theme) {
  theme = theme_;
}
